import { cn } from "@ui/lib/utils";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  placeholder: string;
}

export const Input = ({ label, placeholder, ...props }: InputProps) => {
  return (
    <div className='flex flex-col gap-2'>
      <label className='font-soundboard f-ui-01 mb-12 text-sm font-medium text-light' htmlFor='preset-name'>
        {label}
      </label>
      <input
        className={cn("rounded-sm bg-dark px-12 py-8 text-sm text-default", props.className)}
        id='preset-name'
        name='preset-name'
        placeholder={placeholder}
        type='text'
        {...props}
      />
    </div>
  );
};
